<script>
  import { Button, Modal } from "carbon-components-svelte";
  import { TextArea } from "paxray-components-svelte";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";

  export let currentStep, idproject;

  let anonrules = "";
  let submitModalOpen = false;

  function saveSimpleAnonRules() {
    let anonrulelist = anonrules.split("\n");
    let anonymizationRules = [];
    anonrulelist.forEach((element) => {
      if (element.trim())
        anonymizationRules.push({
          name: "",
          search: element.trim(),
          replace: "",
          reason: "",
        });
    });
    fetchWrapper(`/api/damprojects/saveUserAnonymizations/${idproject}`, {
      method: "POST",
      body: JSON.stringify([{ user: anonymizationRules }]),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "success") {
          currentStep = 4;
          submitModalOpen = false;
        }
      });
  }
</script>

<div style="margin:20px;">
  <h2>Examples for Anonymization</h2>
  <TextArea
    bind:value={anonrules}
    rows="20"
    placeholder="Enter strings that can contain identifiable information and should be anonymized"
  ></TextArea>
  <Button
    on:click={() => {
      submitModalOpen = true;
    }}>Save</Button
  >
</div>
<Modal
  bind:open={submitModalOpen}
  modalHeading="Submit Entries"
  primaryButtonText="Submit"
  secondaryButtonText="Cancel"
  preventCloseOnClickOutside
  on:click:button--secondary={() => (submitModalOpen = false)}
  on:open
  on:close={() => (submitModalOpen = false)}
  on:submit={saveSimpleAnonRules}
>
  <p>Do you want to submit your entries?</p>
  <p>This is a permanent action and cannot be undone.</p>
</Modal>
